export type Choices = Readonly<{
    choicePositive?: Choice;
    choiceNegative?: Choice;
    choiceNa?: Choice;
}>;

export type Choice = Readonly<{
    xmlId: string;
    label: string;
    selected: boolean;
    selectedInMaster: boolean;
    type: CHOICE_TYPE;
}>;

export enum CHOICE_TYPE {
    CHOICE_POSITIVE = 'CHOICE_POSITIVE',
    CHOICE_NEGATIVE = 'CHOICE_NEGATIVE',
    CHOICE_NA = 'CHOICE_NA',
    UNKNOWN = 'UNKNOWN',
}

export const initialChoiceState: Choice = {
    label: '',
    selected: false,
    selectedInMaster: false,
    type: CHOICE_TYPE.UNKNOWN,
    xmlId: '',
};
